"use client";

import { Mail } from "lucide-react";
import "./TrustBar.css";

const SOCIAL_X = "https://x.com/VladBastion";
const SOCIAL_THREADS = "https://www.threads.net/@vladbastion";
const SOCIAL_SUBSTACK = "https://investmentbastion.substack.com/";
const SOCIAL_LINKEDIN = "https://www.linkedin.com/in/vladimir-kiselev-02b0097b/";
const FEEDBACK_MAILTO =
  "mailto:support@investmentbastion.com?subject=" +
  encodeURIComponent("Feedback & ideas for Bastion") +
  "&body=" +
  encodeURIComponent("Hi Vlad,\n\n");

const REVIEWS = [
  {
    quote:
      "A great model, visually easy to navigate, and it makes sense to me.",
    name: "Philip Webster, CFA",
    role: "Fund manager",
  },
  {
    quote: "You give the answers people didn't know they should have asked.",
    name: "Moritz Biber",
    role: "Individual investor",
  },
  {
    quote:
      "Powerful. Nobody offers a heatmap as clear and simple to understand as yours.",
    name: "Alexis Marschall",
    role: "Individual investor, US",
  },
] as const;

function Stars() {
  return (
    <span className="trust__stars" aria-label="5 out of 5">
      {[0, 1, 2, 3, 4].map((i) => (
        <svg key={i} width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2l2.9 6.26 6.87.6-5.2 4.53 1.56 6.71L12 16.9l-6.13 3.71 1.56-6.71-5.2-4.53 6.87-.6z" />
        </svg>
      ))}
    </span>
  );
}

function XIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

function ThreadsIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.85 13.85 0 0 1 3.02.142c-.126-.742-.375-1.332-.75-1.757-.513-.586-1.308-.883-2.359-.89h-.029c-.844 0-1.992.232-2.721 1.32L7.734 7.847c.98-1.454 2.568-2.256 4.478-2.256h.044c3.194.02 5.097 1.975 5.287 5.388.108.046.216.094.321.142 1.49.7 2.58 1.761 3.154 3.07.797 1.82.871 4.79-1.548 7.158-1.848 1.81-4.09 2.628-7.277 2.65Zm1.003-11.69c-.242 0-.487.007-.739.021-1.836.103-2.98.946-2.916 2.143.067 1.256 1.452 1.839 2.784 1.767 1.224-.065 2.818-.543 3.086-3.71a10.5 10.5 0 0 0-2.215-.221z" />
    </svg>
  );
}

function SubstackIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z" />
    </svg>
  );
}

function LinkedInIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
    </svg>
  );
}

export default function TrustBar() {
  return (
    <section className="trust" aria-label="What investors say about Bastion">
      <div className="trust__inner">
        <div className="trust__reviews">
          {REVIEWS.map((review) => (
            <figure className="trust__card" key={review.name}>
              <Stars />
              <blockquote className="trust__quote">{review.quote}</blockquote>
              <figcaption className="trust__author">
                <span className="trust__author-name">{review.name}</span>
                <span className="trust__author-role">{review.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="trust__meta">
          <span className="trust__meta-item">
            <span className="trust__meta-num">15,000+</span> investors follow along
            <span className="trust__socials">
              <a
                className="trust__icon"
                href={SOCIAL_X}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow on X"
              >
                <XIcon />
              </a>
              <a
                className="trust__icon"
                href={SOCIAL_THREADS}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow on Threads"
              >
                <ThreadsIcon />
              </a>
              <a
                className="trust__icon"
                href={SOCIAL_SUBSTACK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Read on Substack"
              >
                <SubstackIcon />
              </a>
            </span>
          </span>

          <span className="trust__meta-item">
            <span className="trust__meta-num">1,100+</span> registered on the terminal
          </span>

          <span className="trust__feedback">
            Feedback or ideas for the roadmap? I&apos;d love to hear them.
            <span className="trust__socials">
              <a
                className="trust__icon"
                href={SOCIAL_LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Connect on LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a className="trust__icon" href={FEEDBACK_MAILTO} aria-label="Email your feedback">
                <Mail size={15} strokeWidth={1.8} />
              </a>
            </span>
          </span>
        </div>
      </div>
    </section>
  );
}
